// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
/*#region Text*/
/*#endregion */
/*#region Elements*/
/**#region Event Container */
/*#endregion*/
/*#endregion */
/* #region Screen */
/* #endregion*/
.input-container {
  display: grid;
  position: relative;
}
.input-container label {
  position: absolute;
  left: 10px;
  top: 4px;
  font-size: 12px;
  color: #7089a4;
  pointer-events: none;
}
.input-container input.invalid {
  border: 2px solid #c85570;
  color: #d297a4;
  background: #84273c;
}

.adjusted {
  position: relative;
  top: 7px;
}

input {
  height: 45px;
  padding-top: 15px;
  text-indent: 10px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: 5px;
  background: #3b5873;
  color: #9dbcda;
  caret-color: #9dbcda;
}
input:disabled {
  background: #3f5061;
  color: #607387;
  opacity: 1;
}
input:focus-visible {
  outline: 2px solid #52aaff;
  outline-offset: 1px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
